import React from 'react';
import { Form } from 'react-bootstrap';


const Jobfindbox = ({
	categories,
	input,
	handleInput,
	handleSubmit
}) => {

	return (
		<div className="section-full browse-job-find">
			<div className="container">
				<div className="find-job-bx">
					<form className="dezPlaceAni" onSubmit={handleSubmit}>
						<div className="row">
							<div className="col-lg-4 col-md-6">
								<div className="form-group">
									<div className="input-group">
										<input
											type="text"
											className="form-control"
											placeholder="Job Title, Keywords, or Phrase"
											name='title'
											value={input?.title || ''}
											onChange={handleInput}
										/>
										<div className="input-group-append">
											<span className="input-group-text"><i className="fa fa-search"></i></span>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="form-group">
									<div className="input-group">
										<input
											type="text"
											className="form-control"
											placeholder="Place, Country.."
											name='place'
											value={input?.place || ''}
											onChange={handleInput}
										/>
										<div className="input-group-append">
											<span className="input-group-text"><i className="fa fa-map-marker"></i></span>
										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="form-group">
									<Form.Control as="select" custom className="select-btn" id='cities' onChange={(e) => handleInput(e, 'dr')}>
										<option value={''}>Select Sector</option>
										{categories?.map(res =>
											<option value={res.id}>{res.name}</option>
										)}
									</Form.Control>
								</div>
							</div>
							<div className="col-lg-2 col-md-6">
								<button className="site-button btn-block" onClick={handleSubmit}>Find Job</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default Jobfindbox;